// src/components/organisms/InteractionDisplay.js

import React from "react";
import PropTypes from "prop-types";
import InteractionTooltip from "../molecules/InteractionTooltip";

const InteractionDisplay = ({ interactions, currentTime }) => {
  return (
    <>
      {interactions.map((interaction) => (
        <InteractionTooltip
          key={interaction.id}
          interaction={interaction}
          currentTime={currentTime}
        />
      ))}
    </>
  );
};

InteractionDisplay.propTypes = {
  interactions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      mediaURL: PropTypes.string,
      mediaType: PropTypes.oneOf(["image", "video"]),
      callToAction: PropTypes.string,
      callToActionURL: PropTypes.string,
      timestamp: PropTypes.number.isRequired,
    })
  ).isRequired,
  currentTime: PropTypes.number.isRequired,
};

export default InteractionDisplay;
